import * as sentry from "@sentry/react";

const trackRedditAnalytics = (
  eventName: string,
  data: Record<string, unknown> = {},
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).rdt === "function"
    ) {
      (window as any).rdt("track", "Custom", {
        customEventName: eventName,
        ...data,
      });
    } else {
      console.warn(`Reddit Pixel is not available. Event: ${eventName}`);
    }
  } catch (e) {
    console.error(`Error in trackRedditAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export default trackRedditAnalytics;
